import { render, staticRenderFns } from "./FooterTreeColumnMobileTheme1.vue?vue&type=template&id=b0be2322&scoped=true"
import script from "./FooterTreeColumnMobileTheme1.vue?vue&type=script&lang=js"
export * from "./FooterTreeColumnMobileTheme1.vue?vue&type=script&lang=js"
import style0 from "./FooterTreeColumnMobileTheme1.vue?vue&type=style&index=0&id=b0be2322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0be2322",
  null
  
)

export default component.exports